import { render, staticRenderFns } from "./Delmaterial.vue?vue&type=template&id=73b0be4c&scoped=true"
import script from "./Delmaterial.vue?vue&type=script&lang=js"
export * from "./Delmaterial.vue?vue&type=script&lang=js"
import style0 from "./Delmaterial.vue?vue&type=style&index=0&id=73b0be4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b0be4c",
  null
  
)

export default component.exports